/** Avatar initials helper — BT-058 */

export function initialsFromDisplayName(displayName) {
  const s = String(displayName || "").trim();
  if (!s) return "?";
  const parts = s.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0].slice(0, 1)}${parts[parts.length - 1].slice(0, 1)}`.toUpperCase();
  }
  return s.slice(0, 1).toUpperCase();
}

export function resolveAvatarDisplayName({ displayName, prenom, nom }) {
  if (displayName) return displayName;
  return [prenom, nom].filter(Boolean).join(" ").trim();
}
